export default __webpack_public_path__ + "static/ReedBeetle-08c7e95ca35ae60fb196ccb6d4b1dbcd.jpeg";